var React = require('react');

function Database (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.5 12.3333C26.0604 12.3333 33 10.0201 33 7.16667C33 4.3132 26.0604 2 17.5 2C8.93959 2 2 4.3132 2 7.16667C2 10.0201 8.93959 12.3333 17.5 12.3333Z","stroke":"white","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M33 19.2222C33 22.0811 26.1111 24.3889 17.5 24.3889C8.88889 24.3889 2 22.0811 2 19.2222","stroke":"white","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M2 7.16666V31.2778C2 34.1367 8.88889 36.4444 17.5 36.4444C26.1111 36.4444 33 34.1367 33 31.2778V7.16666","stroke":"white","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Database.defaultProps = {"width":"24","height":"24","viewBox":"0 0 35 38","fill":"none"};

module.exports = Database;

Database.default = Database;
